export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.max-price.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.max-price.aria-label',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.max-price.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
